export default {
  inject: ['load'],
  data() {
    return {
      allPulseRhythmsForOther: [],
      pulseRhythm: null,
    };
  },
  methods: {
    getListOfPulseRhythmsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPulseRhythms').then(() => {
        if (this.$store.state.pulseRhythmModule.successFlag) {
          this.allPulseRhythmsForOther = this.$store.state.pulseRhythmModule.allPulseRhythms;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.pulseRhythmModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfPulseRhythmsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getPulseRhythmFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPulseRhythm', id).then(() => {
        if (this.$store.state.pulseRhythmModule.successFlag) {
          this.pulseRhythm = this.$store.state.pulseRhythmModule.pulseRhythm;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.pulseRhythmModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getPulseRhythmFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.pulseRhythmModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
